import React, { useState, useCallback } from "react";
import {
  Button,
  Card,
  CardActionArea,
  CardMedia,
  Divider,
  Grid,
  Typography,
} from "@mui/material";

function BasicInformation({ data, img }) {
  return (
    <>
      <div className="pb-2">
        <Grid container spacing={2}>
          <Grid item xs={8}>
            <h5>Basic Information</h5>
            <Typography color="primary" variant="h6">
              Full Name
            </Typography>
            <Typography variant="subtitle1" style={{ color: "#595959" }}>
              {data.full_name}
            </Typography>
            <Typography color="primary" variant="h6">
              Short Name
            </Typography>
            <Typography variant="subtitle1" style={{ color: "#595959" }}>
              {data.short_name}
            </Typography>
            <Typography color="primary" variant="h6">
              Gender
            </Typography>
            <Typography variant="subtitle1" style={{ color: "#595959" }}>
              {data.gender === "M" ? "Male" : "Female"}
            </Typography>
            <Typography color="primary" variant="h6">
              Place of Birth
            </Typography>
            <Typography variant="subtitle1" style={{ color: "#595959" }}>
              {data.birth_location}
            </Typography>
            <Typography color="primary" variant="h6">
              Date of Birth
            </Typography>
            <Typography variant="subtitle1" style={{ color: "#595959" }}>
              {data.birth_date}
            </Typography>
            <Typography color="primary" variant="h6">
              Email
            </Typography>
            <Typography variant="subtitle1" style={{ color: "#595959" }}>
              {data.email}
            </Typography>
            <Typography color="primary" variant="h6">
              Phone Number
            </Typography>
            <Typography variant="subtitle1" style={{ color: "#595959" }}>
              {data.phone_number}
            </Typography>
            <Typography color="primary" variant="h6">
              Address
            </Typography>
            <Typography variant="subtitle1" style={{ color: "#595959" }}>
              {data.address}
            </Typography>
          </Grid>
          <Grid item xs={4} justifyContent={"flex-end"}>
              <img src={img} alt="" width={"175px"} />
          </Grid>
        </Grid>
      </div>
      <Divider />
    </>
  );
}

export default BasicInformation;
